module.exports = __webpack_public_path__ + "img/sd.f6240321.gif";